var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveryIoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 28,
    viewBox: "0 0 110 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5723 8.90387L12.7625 1L10.3418 1.55075L12.1514 9.45324C12.8836 9.10117 13.7049 8.90387 14.5723 8.90387Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1337 13.2275H1V15.7024H9.13319C9.04233 15.3044 8.99345 14.8905 8.99345 14.4649C8.99345 14.0395 9.04285 13.6258 9.1337 13.2275Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13229 15.7021L1.80469 19.2195L2.88196 21.4491L10.2097 17.9317L5.13859 24.2701L7.07982 25.8132L12.1503 19.4756C10.6421 18.7503 9.51246 17.3682 9.13229 15.7021Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8026 1.55075L16.3821 1L14.5723 8.90387C15.4397 8.90387 16.2608 9.10134 16.9932 9.45342L18.8026 1.55075Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1519 9.45339L7.08178 3.11621L5.14054 4.65932L10.2115 10.9974L2.88391 7.48005L1.80664 9.70974L9.13459 13.2272C9.51458 11.561 10.6438 10.1787 12.1519 9.45339Z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1171 13.2275H20.0121H13.3887V15.7024H20.0114H28.1171H28.1451V13.2275H28.1171Z",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2625 7.48022L18.9342 10.9979L24.0055 4.65932L22.0643 3.11621L16.9941 9.45356C18.5024 10.1789 19.632 11.5612 20.012 13.2274L27.3399 9.70991L26.2625 7.48022Z",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9941 19.4766L22.0646 25.8142L24.0057 24.2711L18.9338 17.9316C18.4139 18.5807 17.7522 19.112 16.9941 19.4766Z",
    fill: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5721 20.0259C13.7047 20.0259 12.8836 19.8286 12.1514 19.4766L10.3418 27.3791L12.7623 27.9296L14.5721 20.0259L16.3821 27.9298L18.8026 27.3791L16.993 19.4766C16.2607 19.8286 15.4395 20.0259 14.5721 20.0259Z",
    fill: "#000000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9674 22.3366L54.6523 7.49121H57.7187L61.6027 19.3965H61.6611L65.4869 7.49121H68.4949L63.1797 22.3366H59.9674Z",
    fill: "#000000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.495 15.6716C83.5145 15.5163 83.5242 15.1573 83.5242 14.5945C83.5242 12.2658 82.9012 10.4223 81.6551 9.06393C80.4286 7.70555 78.6959 7.02637 76.4569 7.02637C74.9578 7.02637 73.6534 7.35623 72.5437 8.01614C71.4339 8.67587 70.5772 9.59763 69.9737 10.7814C69.3896 11.9652 69.0977 13.3332 69.0977 14.8856C69.0977 16.4188 69.3799 17.7771 69.9445 18.9608C70.5285 20.1446 71.3755 21.076 72.4853 21.7552C73.595 22.4343 74.9188 22.774 76.4569 22.774C78.3259 22.774 79.8348 22.318 80.9834 21.4058C81.8405 20.7254 82.4916 19.8774 82.9369 18.8619L80.3765 17.9331C80.1656 18.5479 79.774 19.1136 79.2021 19.6303C78.5791 20.1737 77.6834 20.4453 76.5152 20.4453C75.1136 20.4453 74.0232 19.9893 73.2446 19.0773C72.4853 18.1457 72.0861 17.0105 72.0472 15.6716H83.495ZM79.3773 10.5194C80.1366 11.2762 80.5162 12.2465 80.5162 13.4302H72.0472C72.125 12.2076 72.5632 11.2277 73.3613 10.4903C74.1595 9.73347 75.1621 9.35506 76.3693 9.35506C77.6153 9.35506 78.618 9.74311 79.3773 10.5194Z",
    fill: "#000000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7001 15.6862C53.7196 15.5309 53.7293 15.172 53.7293 14.6092C53.7293 12.2805 53.1062 10.4369 51.8602 9.07857C50.6337 7.7202 48.901 7.04102 46.6619 7.04102C45.1629 7.04102 43.8585 7.37088 42.7487 8.03079C41.639 8.69069 40.7823 9.61228 40.1788 10.7961C39.5946 11.9799 39.3027 13.3479 39.3027 14.9003C39.3027 16.4332 39.585 17.7918 40.1496 18.9754C40.7336 20.1592 41.5806 21.0906 42.6904 21.7698C43.8001 22.449 45.1238 22.7887 46.6619 22.7887C48.531 22.7887 50.0399 22.3326 51.1885 21.4205C52.0456 20.7401 52.6967 19.892 53.142 18.8766L50.5816 17.9478C50.3707 18.5626 49.9791 19.1283 49.4072 19.645C48.7842 20.1883 47.8885 20.46 46.7203 20.46C45.3187 20.46 44.2283 20.0039 43.4496 19.092C42.6904 18.1604 42.2912 17.0251 42.2523 15.6862H53.7001ZM49.5824 10.534C50.3416 11.2909 50.7213 12.2612 50.7213 13.4448H42.2523C42.3301 12.2223 42.7683 11.2423 43.5664 10.505C44.3646 9.74812 45.3672 9.3697 46.5744 9.3697C47.8204 9.3697 48.8231 9.75776 49.5824 10.534Z",
    fill: "#000000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9824 9.95257C85.9824 8.52637 87.1424 7.37012 88.5733 7.37012H95.9143V7.37081H96.4444L100.844 18.8488H100.903L105.066 7.37081H108.078L102.143 22.7337C101.415 24.5584 100.647 25.8338 99.8402 26.5597C99.0969 27.2449 98.1784 27.6068 97.0844 27.6452V27.6491H94.4756V25.1768H96.2575V25.1765H96.2674C97.8421 25.1765 98.8854 24.1955 99.3971 22.2334L94.299 9.83654H88.8951V22.3377H85.9824V9.95257Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveryIoLogo);
export default __webpack_public_path__ + "static/media/everyIoLogo.3033e2009b39e76490abf7d13dffc737.svg";
export { ForwardRef as ReactComponent };